import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-line-add-button',
  templateUrl: './line-add-button.component.html',
  styleUrls: ['./line-add-button.component.scss']
})
export class LineAddButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
